<script lang="ts">
    import dayjs from "dayjs";
    import {Language, setLocale} from "$lib/utils/i18nDate";
    import {getEventsByDay} from "$lib/calls/calendar";
    import {goto} from "$app/navigation";
    import fromEntityStore, {descriptionFromEntityStore} from "$lib/utils/fromEntityStore";
    import DispoBadge from "$lib/components/DispoBadge.svelte";
    import {fly} from "svelte/transition";
    import advancedFormat from "dayjs/plugin/advancedFormat"
    import weekyear from "dayjs/plugin/weekYear"
    import weekofyear from "dayjs/plugin/weekOfYear"


    dayjs.extend(weekofyear)
    dayjs.extend(weekyear)
    dayjs.extend(advancedFormat)

    import {DateInput} from "date-picker-svelte";
    import PageLayout from "$lib/components/PageLayout.svelte";

    export let data;

    setLocale(Language.de);

    let shownDays = "3";

    const move = (date: string) => {
        goto(`/calendar/${date}`)
    }
    const moveBackward = (steps: number = 7) => {
        move(data.days[0].subtract(steps, 'day').format('YYYY-MM-DD'))
    }
    const moveForward = (steps: number = 7) => {
        move(data.days[0].add(steps, 'day').format('YYYY-MM-DD'))
    }

    const moveToWeek = (event: InputEvent) => {
        const t = dayjs(event.target.value.split('-W')[0] + '-01-01').add(event.target.value.split('-W')[1], 'week').format('YYYY-MM-DD')
        move(t)
    }

    let showHoverInteraction = {
        left: false,
        right: false
    }


</script>
<PageLayout>
    <div class="flex gap-3 justify-between mb-2 pb-5 bg-white rounded-md shadow-sm">
        <div on:mouseleave={() => showHoverInteraction.left = false} on:mouseenter={() => showHoverInteraction.left = true}
             class="pt-8 pl-3 cursor-pointer relative">
            <svg on:click={() => moveBackward(1)} class="w-7" fill="none" stroke="currentColor" stroke-width="1.5"
                 viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5"></path>
            </svg>
            {#if showHoverInteraction.left}
                <div transition:fly|global class="isolate inline-flex rounded-md shadow-sm absolute top-5 left-10 w-full">
                    <button on:click={() => moveBackward(3)} type="button"
                            class="relative inline-flex items-center rounded-l-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10">
                        -3 Tage
                    </button>
                    <button on:click={() => moveBackward(5)} type="button"
                            class="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10">
                        -5 Tage
                    </button>
                    <button on:click={() => moveBackward(7)} type="button"
                            class="relative -ml-px inline-flex items-center rounded-r-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10">
                        -1 Woche
                    </button>

                </div>
            {/if}
        </div>
        <div class="input">
            <!--        <label for="week">Kalenderwoche</label>-->
            <input id="week" type="week" value={data.start.format('YYYY-[W]w')} on:change={moveToWeek}>
        </div>


        <div class="input w-44">
            <select class="pr-10" bind:value={shownDays}>
                <option value="3">3 Tagesansicht</option>
                <option value="5">5 Tagesansicht</option>
                <option value="7">Wochenansicht</option>
            </select>
        </div>

        <div class="input">
            <!--        <label for="day">Datumsauswahl</label>-->
            <input id="day" type="date" value={data.start.format('YYYY-MM-DD')} on:input={ev => move(ev.target.value)}>
        </div>
        <div on:mouseleave={() => showHoverInteraction.right = false}
             on:mouseenter={() => showHoverInteraction.right = true} class="pt-8 pr-3 cursor-pointer relative">
            <svg on:click={() => moveForward(1)} class="w-7" fill="none" stroke="currentColor" stroke-width="1.5"
                 viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5"></path>
            </svg>
            {#if showHoverInteraction.right}
                <div transition:fly|global class="isolate inline-flex rounded-md shadow-sm absolute top-5 right-48 w-full">
                    <button on:click={() => moveForward(3)} type="button"
                            class="relative inline-flex items-center rounded-l-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10">
                        +3 Tage
                    </button>
                    <button on:click={() => moveForward(5)} type="button"
                            class="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10">
                        +5 Tage
                    </button>
                    <button on:click={() => moveForward(7)} type="button"
                            class="relative -ml-px inline-flex items-center rounded-r-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10">
                        +1 Woche
                    </button>

                </div>
            {/if}
        </div>
    </div>

    <div>

        <div class:grid-cols-7={shownDays === '7'} class:grid-cols-5={shownDays === '5'}
             class:grid-cols-3={shownDays === '3'} class="grid gap-1">
            {#each data.days as day, index}
                {#if index < parseInt(shownDays)}
                    <div class="day">
                        <div class="py-3 bg-coolGray-200 text-center">{day.format('dddd, DD.MM')}</div>
                        {#await getEventsByDay(day.format('YYYY-MM-DD')) then events}
                            {#each events.projects as project}
                                <!--Only when event is present-->
                                {#if fromEntityStore(project, 'event') && project.status !== 'canceled'}
                                    <div class="event mb-4 rounded"
                                         style:background-color={descriptionFromEntityStore(project, 'event') }>

                                        <div class="">
                                            <div class="pl-2 py-2 rounded-lt rounded-rt text-sm font-medium text-body  truncate">{project.customer.name}</div>
                                        </div>

                                        <div class="flex justify-between gap-x-4 border-b border-gray-900/5 p-3 bg-white">

                                            <a href={'/project/' + project.uuid}
                                               class="text-sm font-medium leading-6 text-gray-900 flex-1">{project.name}</a>
                                            <div class="w-14 ">
                                                <DispoBadge {project}/>
                                                <button type="button" class=" block p-2.5 text-gray-400 hover:text-gray-500"
                                                        id="options-menu-0-button" aria-expanded="false"
                                                        aria-haspopup="true">
                                                    <span class="sr-only">Open options</span>
                                                    <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"
                                                         aria-hidden="true">
                                                        <path d="M3 10a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM8.5 10a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM15.5 8.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"/>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                        <dl class="-my-3 divide-y divide-gray-100 px-6 py-4 text-sm leading-6 relative">


                                            <!--
                                              Dropdown menu, show/hide based on menu state.

                                              Entering: "transition ease-out duration-100"
                                                From: "transform opacity-0 scale-95"
                                                To: "transform opacity-100 scale-100"
                                              Leaving: "transition ease-in duration-75"
                                                From: "transform opacity-100 scale-100"
                                                To: "transform opacity-0 scale-95"
                                            -->
                                            <div class="hidden absolute right-0 z-10 mt-0.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none"
                                                 role="menu" aria-orientation="vertical"
                                                 aria-labelledby="options-menu-0-button" tabindex="-1">
                                                <!-- Active: "bg-gray-50", Not Active: "" -->
                                                <a href="#" class="block px-3 py-1 text-sm leading-6 text-gray-900"
                                                   role="menuitem" tabindex="-1" id="options-menu-0-item-0">View<span
                                                        class="sr-only">, Tuple</span></a>
                                                <a href="#" class="block px-3 py-1 text-sm leading-6 text-gray-900"
                                                   role="menuitem" tabindex="-1" id="options-menu-0-item-1">Edit<span
                                                        class="sr-only">, Tuple</span></a>
                                            </div>


                                        </dl>
                                    </div>
                                {/if}
                            {/each}
                        {/await}
                    </div>
                {/if}
            {/each}
        </div>

    </div>
</PageLayout>

